<template>
  <div class="item_header" @click.stop="changeExpandStatus()">
    <div :class="classObject">
      <BaseIcon icon="$mdiLogin" class="icon" />
    </div>
    <div class="sections">
      <div class="section_top">
        <div class="section_left">
          <div class="section_title" v-text="record.courseName" />
          <div
            class="section_content"
            v-text="
              $t('folder.createdAt', {
                date: $d(new Date(record.dateCreated), 'veryshort'),
              })
            "
          />
        </div>
        <div class="section_center">
          <div class="section_title" v-text="$tc('utils.contact', 1)" />
          <div
            v-if="record.client && record.client.fullName"
            class="section_content"
            v-text="record.client.fullName"
          />
          <div
            class="section_footer"
            :class="{ text_primary: record.status != 'INVITED' }"
            v-text="record.email"
          />
        </div>
        <div class="section_right">
          <div class="chips" :class="recordStatus.chipsClass">
            {{ recordStatus.label }}
          </div>
        </div>
      </div>
    </div>
    <div class="icon_right">
      <v-btn icon @click.stop="changeExpandStatus()">
        <BaseIcon :icon="expanded ? '$mdiChevronUp' : '$mdiChevronDown'" />
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "FolderRecordItemHeader",
  props: {
    expanded: {
      type: Boolean,
      required: true,
    },
    record: {
      type: Object,
      required: true,
    },
    isUpdated: {
      type: Boolean,
    },
  },
  computed: {
    recordStatus() {
      let recordStatus = {
        label: "En attente de renseignement",
        chipsClass: "",
      };
      if (this.record.isCompleted) {
        recordStatus.label = this.$t("organization.recordDone");
        recordStatus.chipsClass = "chips_success";
      }
      return recordStatus;
    },
    classObject() {
      const clas = ["icon_left"];
      if (this.isUpdated) clas.push("updated");
      switch (this.record.validationStatus) {
        case "UPDATE_REQUESTED":
          clas.push("need_update");
          break;
        case "VALIDATED":
          clas.push("validated");
          break;
        case "UPDATED":
          clas.push("updated");
          break;
        default:
          "";
          break;
      }
      return clas;
    },
  },
  methods: {
    changeExpandStatus() {
      this.$emit("expandChange");
    },
  },
};
</script>

<style lang="scss" scoped>
.item_header {
  display: flex;
  cursor: pointer;
  .icon_left {
    width: 32px;
    background: #b6bdff;
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &.AGREE {
      background: #18a300;
    }
    &.DISAGREE {
      background: #ff5267;
    }
    & > .icon {
      &::v-deep {
        .v-icon {
          width: 16px;
          height: 16px;
          color: #fff;
        }
      }
    }
  }
  .need_update {
    background: #ff5b60;
    & > .icon {
      &::v-deep {
        .v-icon {
          color: white;
        }
      }
    }
  }
  .updated {
    background: #ffab5a;
    & > .icon {
      &::v-deep {
        .v-icon {
          color: white;
        }
      }
    }
  }
  .validated {
    background: #18a300;
    & > .icon {
      &::v-deep {
        .v-icon {
          color: white;
        }
      }
    }
  }

  .updated {
    background: #ffab5a;
  }
  .sections {
    padding: 16px;
    flex: 1;
    .section_top {
      display: flex;
      align-items: center;
      .section_left {
        padding: 8px;
        padding-left: 16px;
        flex: 1;
        font-family: "Inter";
        font-style: normal;
        .section_title {
          font-weight: 600;
          font-size: 24px;
          line-height: 28px;
          color: #4f4f4f;
        }
        .section_content {
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          color: #707080;
          margin-top: 6px;
        }
      }
      .section_center {
        padding: 8px;
        flex: 1;
        .section_title {
          font-family: "Inter";
          font-style: normal;
          font-weight: 400;
          font-size: 10px;
          line-height: 12px;
          display: flex;
          align-items: center;
          text-transform: uppercase;
          color: #707080;
        }
        .section_content {
          font-family: "Inter";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
          color: #353542;
          margin-top: 6px;
        }
        .section_footer {
          font-family: "Inter";
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 16px;
          color: #707080;
          margin-top: 6px;
          &.text_primary {
            color: #2536cc;
          }
        }
      }
      .section_right {
        width: 200px;
        flex: none;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .chips {
          background: #eeeef7;
          font-family: "Inter";
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 16px;
          color: #707080;
          padding: 4px 8px;
          border-radius: 24px;
          &.chips_success {
            background: #f0ffd6;
            color: #18a300;
          }
          &.chips_danger {
            background: #fef9fa;
            color: #ff5267;
          }
        }
      }
    }
  }
  .icon_right {
    flex: none;
    width: 76px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
}
</style>
